const CLASSES = {
  Pending: "bg-amber-100 text-amber-800 border-amber-200",
  "In Progress": "bg-blue-100 text-blue-800 border-blue-200",
  Completed: "bg-emerald-100 text-emerald-800 border-emerald-200",
  "On Hold": "bg-rose-100 text-rose-800 border-rose-200",
};

export function StatusBadge({ status }) {
  const cls = CLASSES[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`status-badge-${status.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-semibold ${cls}`}
    >
      {status}
    </span>
  );
}

export const CHECK_TYPE_LABEL = {
  address: "Address Verification",
  litigation: "Litigation Check",
  id: "ID Check",
};
